import { render } from "./MechanismList.vue?vue&type=template&id=0e8c0a5d&scoped=true"
import script from "./MechanismList.vue?vue&type=script&lang=ts"
export * from "./MechanismList.vue?vue&type=script&lang=ts"

import "./MechanismList.vue?vue&type=style&index=0&id=0e8c0a5d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0e8c0a5d"

export default script